import { render, staticRenderFns } from "./calcSalary.vue?vue&type=template&id=ed18a6f4&scoped=true&"
import script from "./calcSalary.vue?vue&type=script&lang=js&"
export * from "./calcSalary.vue?vue&type=script&lang=js&"
import style0 from "./calcSalary.vue?vue&type=style&index=0&id=ed18a6f4&prod&lang=scss&scoped=true&"
import style1 from "./calcSalary.vue?vue&type=style&index=1&id=ed18a6f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed18a6f4",
  null
  
)

export default component.exports